import { useCallback, useMemo } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Icon from 'icons/Icon'
import { getGameUrl, isMobileDevice, isNewGame } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { getItem } from 'utils/storageUtils'
import RestrictedOverlay from '../RestrictedOverlay'
import './styles/index.scss'
import { getProcessedProviderName } from 'utils/provider'

const GameCardV2 = ({
  game,
  index,
  toggleFavorite,
  selectedLanguageCode,
  playGameCallback,
  isLabeled,
  labelIconUrl,
  selected,
  disablePlay = false,
  onSelect,
  favoriteGamesList,
  disableDemoPlay = false
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { languageData } = useSelector((state) => state.language)
  const { gameFilterSupportType } = useSelector((state) => state.uiConfig.general) || {}

  const loggedIn = JSON.parse(getItem('loggedIn'))

  const selectableProps = useMemo(() => {
    if (onSelect) {
      return {
        onClick: () => {
          onSelect(game?.identifier)
        }
      }
    }

    return {}
  }, [onSelect, game?.identifier])

  const onClickPlay = useCallback(() => {
    if (location?.pathname) {
      window.previousScreen = location.pathname
    }
    if (playGameCallback) {
      playGameCallback()
    }
  }, [])

  const onClickMobilePlay = useCallback(() => {
    onClickPlay()
    navigate(getGameUrl(selectedLanguageCode?.toLowerCase(), game?.gameId, game?.name, game?.providerName))
  }, [])

  const getFavoriteIcon = () => {
    if (toggleFavorite && loggedIn) {
      return (
        <>
          <div
            className='favorite-icon-container'
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              toggleFavorite({
                isFavorite: favoriteGamesList?.rows?.some((el) => el.id === game?.id),
                id: game?.id,
                subCategoryId: +game?.subCategoryId
              })
            }}
          >
            <Icon
              name={favoriteGamesList?.rows?.some((el) => el.id === game?.id)
                ? 'game-card-fav-solid'
                : 'game-card-fav-light'}
            />
          </div>
        </>
      )
    }

    return null
  }

  const processedProviderName = getProcessedProviderName(game, gameFilterSupportType)

  return (
    <>
      <div
        key={`list-menu-item-${index}`}
        className={`game-card-v2 ${onSelect ? 'selectable' : ''}`}
        {...selectableProps}
      >
        <div className={`game-container ${selected ? 'selected' : ''}`}>
          <div className='game-card' onClick={isMobileDevice() && !onSelect ? onClickMobilePlay : () => { }}>
            <img
              loading='lazy'
              src={game?.thumbnailUrl || game?.gameThumbnailUrl || languageData?.gameCardPlaceholderImage || '/images/placeholder.svg'}
              onError={(e) => {
                e.target.onerror = null
                e.target.src = languageData?.gameCardPlaceholderImage || '/images/placeholder.svg'
              }}
              className='w-100 game-img'
              alt='game'
            />

            {game?.restrictedGame
              ? <RestrictedOverlay />
              : (
                <div className={`hover-area ${isMobileDevice() ? 'disable-hover' : ''}`}>
                  <div className='hover-content'>
                    <div className='fav-icon'>
                      {getFavoriteIcon()}
                    </div>

                    <span className='hover-content-buttons'>
                      {!disablePlay && (
                        <Link
                          className='play-button'
                          to={getGameUrl(selectedLanguageCode?.toLowerCase(), game?.gameId, game?.name, game?.providerName, game?.demo && !disableDemoPlay && !loggedIn)}
                          onClick={onClickPlay}
                        >
                          <Icon name='game-card-play' /> <span className='play-button-text'>{languageData?.playButtonText || 'Start Playing'}</span>
                        </Link>
                      )}
                    </span>
                    <div className='hover-game-name'>{game?.name}</div>
                    <div className='hover-game-studio'>
                      <span className='hover-game-studio-name'>
                        {processedProviderName}
                      </span>
                    </div>
                  </div>
                </div>
                )}

            {(isNewGame(game?.moreDetails?.released_at) || !!isLabeled) && (
              <div className='game-tag-wrapper'>
                <div className='game-tag new'>
                  {(isLabeled && labelIconUrl)
                    ? <img src={labelIconUrl} alt='Icon' />
                    : <Icon name='sparkles' width='14' height='14' />}
                </div>
              </div>
            )}
            <div className='fav-icon'>
              {getFavoriteIcon()}
            </div>

            <div className='lobby-game-info'>
              <div className='lobby-game-name'>{game?.name}</div>
              <div className='lobby-game-studio'>
                <span className='lobby-game-studio-name'>
                  {processedProviderName}
                </span>
              </div>
            </div>
            <div className='mobile-background-layout' />
          </div>
        </div >
      </div >
    </>
  )
}

export default GameCardV2
